/**
 * @param ordersList {Array}
 * @param search {String}
 */
export function formatOptions(ordersList, search) {
  const searchId = removeLettersFromId(search);
  const isJourneySearch = search[0] === 'J';
  const isShipperOrderSearch = search[0] === 'S';

  const options = ordersList?.map(({ id, childs, type }) => {
    if (type === 'SO' || !childs || !childs.length) {
      return {};
    }

    const journeyId = formatJourneyId(id);
    const shipperOrderId = getShipperOrderIdToDisplay(childs, searchId);
    const journeyIdMatchesSearch = journeyId.includes(search);

    if (isShipperOrderSearch && !shipperOrdersMatchSearch(childs, searchId)) return {};
    if (isJourneySearch && !journeyIdMatchesSearch) return {};

    return {
      journeyId,
      shipperOrderId,
      isJourneySearch,
      isShipperOrderSearch,
      journeyIdMatchesSearch,
      shipperOrderIdMatchesSearch: shipperOrderId.includes(search),
    };
  });

  const filteredOptions = options?.filter((option) => !!option.journeyId);

  return filteredOptions?.length ? filteredOptions : [{ noJourney: true }];
}

/**
 * @param orders
 * @param search
 */
const shipperOrdersMatchSearch = (orders, search) =>
  (orders || []).filter((so) => so.id === Number(search)).length;

/**
 * @param id {Number}
 */
export function formatJourneyId(id) {
  return `J${id}`;
}

/**
 * @param list {Array}
 * @param searchId {Number}
 */
export function findSearchedOrder(list, searchId) {
  return (list || []).find(({ id }) => id === searchId);
}

/**
 * @param list {Array}
 * @param searchId {Number}
 */
export function getShipperOrderIdToDisplay(list, searchId) {
  if (!list || !list.length) return;

  const searchedOrder = findSearchedOrder(list, searchId);

  if (!!searchedOrder) return `S${searchedOrder.id}`;
  if ((list || []).length > 1) return `${list.length} SOs`;
  return `S${list[0].id}`;
}

/**
 * @param id {String}
 */
export function removeLettersFromId(id) {
  return typeof id === 'string' && id.replace(/\D/g, '');
}
